// ═══════════════════════════════════════════════════════════════════
//  modules/wiki/utils.js
//  wikiIlYA
// ═══════════════════════════════════════════════════════════════════

export function wikiIlYA(ts) {
  const s = Math.floor((Date.now() - ts) / 1000);
  if (s < 60) return "à l'instant";
  if (s < 3600) return `il y a ${Math.floor(s / 60)} min`;
  if (s < 86400) return `il y a ${Math.floor(s / 3600)} h`;
  return `il y a ${Math.floor(s / 86400)} j`;
}
